import { FilterCriteria, filterInitialState } from './filterCriteriaReducer';
import { QuickFilterRelatedData } from './loadQuickFilterRelatedData';

export function assembleHydratedQuickFilter({
  filter,
  related,
}: {
  filter: FilterCriteria;
  related: QuickFilterRelatedData;
}): {
  filterCriteria: FilterCriteria;
  accordionStates: Record<string, boolean>;
  missingFilters: string[];
} {
  const {
    groups,
    geometries,
    branches,
    users,
    campaigns,
    eventCampaigns,
    events,
    eventTypes,
    lists,
    callingStatusLists,
    tags,
    mailings,
    missingFilters,
  } = related;

  const filterCriteria: FilterCriteria = {
    ...filterInitialState,
    ...filter,
    eventDateRange: {
      ...(filter.eventDateRange ?? { startDate: null, endDate: null }),
      startDate:
        typeof filter.eventDateRange?.startDate === 'string'
          ? new Date(filter.eventDateRange.startDate)
          : (filter.eventDateRange?.startDate ?? null),
      endDate:
        typeof filter.eventDateRange?.endDate === 'string'
          ? new Date(filter.eventDateRange.endDate)
          : (filter.eventDateRange?.endDate ?? null),
    },
    activityDateRange: {
      ...(filter.activityDateRange ?? filterInitialState.activityDateRange),
      displayedStartDate:
        typeof filter.activityDateRange?.displayedStartDate === 'string'
          ? new Date(filter.activityDateRange.displayedStartDate)
          : (filter.activityDateRange?.displayedStartDate ?? null),
      displayedEndDate:
        typeof filter.activityDateRange?.displayedEndDate === 'string'
          ? new Date(filter.activityDateRange.displayedEndDate)
          : (filter.activityDateRange?.displayedEndDate ?? null),
    },
    callingstatusDateRange: {
      ...(filter.callingstatusDateRange ?? filterInitialState.callingstatusDateRange),
      displayedStartDate:
        typeof filter.callingstatusDateRange?.displayedStartDate === 'string'
          ? new Date(filter.callingstatusDateRange.displayedStartDate)
          : (filter.callingstatusDateRange?.displayedStartDate ?? null),
      displayedEndDate:
        typeof filter.callingstatusDateRange?.displayedEndDate === 'string'
          ? new Date(filter.callingstatusDateRange.displayedEndDate)
          : (filter.callingstatusDateRange?.displayedEndDate ?? null),
    },
    groups,
    geometries,
    branches,
    lists,
    callingstatusCampaigns: campaigns,
    callingstatusUsers: users,
    callingstatusLists: callingStatusLists,
    eventTypes,
    eventCampaigns,
    events,
    tags,
    mailings,
  };

  return {
    filterCriteria,
    accordionStates: {
      location: (filter.geometries ?? []).length > 0,
      tasks: (filter.taskelections ?? []).length > 0,
      supporters: (filter.supporterstatuses ?? []).length > 0,
      membership: (filter.memberships ?? []).length > 0,
      contactable:
        filter.contactable !== undefined &&
        (filter.contactable.hasPhone !== undefined || filter.contactable.hasEmail !== undefined),
      engagement: (filter.activities ?? []).length > 0,
      mailing: (filter.mailings ?? []).length > 0,
      roster: filter.election !== null,
      events:
        (filter.eventTypes ?? []).length > 0 ||
        (filter.statuses ?? []).length > 0 ||
        (filter.eventCampaigns ?? []).length > 0 ||
        (filter.events ?? []).length > 0,
      tags: (filter.tags ?? []).length > 0,
      groups: (filter.groups ?? []).length > 0,
      lists: (filter.lists ?? []).length > 0,
      age: !!filter.age?.value,
      branches: (filter.branches ?? []).length > 0,
      pathwaySteps: (filter.pathwaySteps ?? []).length > 0,
      callingStatus: (filter.callingstatuses ?? []).length > 0,
    },
    missingFilters,
  };
}
